module.exports = __webpack_public_path__ + "img/error-404.8f5d727c.png";